import { Pipe, PipeTransform } from '@angular/core';

const SLUG_SEPARATOR = /_+/;

@Pipe({
  name: 'fieldLabel',
  standalone: true,
})
export class FieldLabelPipe implements PipeTransform {
  // Los campos homologados llegan con una clave tecnica en snake_case (por
  // ejemplo `primer_nombre`) mientras los no homologados conservan su nombre con
  // espacios. Este pipe unifica la presentacion sin tocar el valor persistido,
  // que se sigue usando como identificador del campo.
  transform(value: string | null | undefined, fallback?: string | null): string {
    const candidates = [value, fallback];
    for (const candidate of candidates) {
      const resolved = this.resolve(candidate);
      if (resolved) {
        return resolved;
      }
    }
    // Ningun candidato produjo un nombre util: se muestra el primero tal cual
    // antes que dejar el campo sin etiqueta.
    for (const candidate of candidates) {
      const trimmed = this.clean(candidate);
      if (trimmed) {
        return trimmed;
      }
    }
    return '';
  }

  // Devuelve vacio cuando el candidato no da un nombre presentable, para que el
  // siguiente tenga su turno.
  private resolve(candidate: string | null | undefined): string {
    const trimmed = this.clean(candidate);
    if (!trimmed || !SLUG_SEPARATOR.test(trimmed)) {
      return trimmed;
    }
    return this.humanize(trimmed);
  }

  private clean(candidate: string | null | undefined): string {
    return String(candidate ?? '').trim();
  }

  // Se capitaliza solo la inicial de la primera palabra, no la de cada una: el
  // nombre que configura el gestor se escribe como una frase ("Lugar de
  // nacimiento"), y capitalizar todas devolvia "Lugar De Nacimiento". El resto de
  // cada palabra se conserva tal cual para no arruinar siglas (DPI, NIT).
  private humanize(label: string): string {
    const words = label.split(SLUG_SEPARATOR).filter((word) => word.length > 0);
    if (words.length === 0) {
      return '';
    }
    const [first, ...rest] = words;
    return [first.charAt(0).toUpperCase() + first.slice(1), ...rest].join(' ');
  }
}
